import request from "./request";
import { RequestError } from "@/utils/errors";

const user = {
  service() {
    return {
      list(params) {
        return request.get("/users-api/users", params);
      },
      listSearch(params) {
        return request
          .get("/users-api/users", params)
          .then((resp) => {
            return {
              resp: resp,
              params: params,
            };
          })
          .catch((e) => {
            throw new RequestError(e, { resp: e.response, params: params });
          });
      },
      getById(id) {
        return request.get(`/users-api/users/${id}`);
      },
      patchUser(id, data) {
        return request.patch(`/users-api/users/${id}`, data);
      },
      postUser(user) {
        return request.post("/users-api/users", user);
      },
      deleteUser(id) {
        return request.delete(`/users-api/users/${id}`);
      },
      roles() {
        return request.get("/users-api/userRoles", null);
      },
      postRole(userId, role) {
        return request.post(`/users-api/users/${userId}/roles`, role);
      },
      deleteRole(userId, roleId) {
        return request.delete(`/users-api/users/${userId}/roles/${roleId}`);
      },
      createInvite(data) {
        return request.post(`/users-api/invites`, data);
      },
      getFlexAttributes() {
        return request.get(`/users-api/flexAttributes`);
      },
      postFlexAttribute(userId, attr) {
        return request.post(`/users-api/users/${userId}/flexAttributes`, attr);
      },
      patchFlexAttribute(userId, attr) {
        return request.patch(
          `/users-api/users/${userId}/flexAttributes/${attr.id}`,
          attr,
        );
      },
      deleteFlexAttribute(userId, attrName) {
        return request.delete(
          `/users-api/users/${userId}/flexAttributes/${attrName}`,
        );
      },
      getAnnouncements(params) {
        return request.get(`/users-api/announcements`, params);
      },
      postAnnouncement(data) {
        return request.post(`/users-api/announcements`, data);
      },
      postAnnouncementStatus(data) {
        return request.post(`/users-api/announcements/status`, data);
      },
      getTemplates(params) {
        return request.get(`/users-api/emailSettings/templates`, params);
      },
      getUserEmailSettings(email, params) {
        // odd hack to NOT url encode the email. API doesn't support url encoded emails
        if (email) {
          return request.get(`/users-api/emailSettings?email=${email}`, params);
        }

        return request.get(`/users-api/emailSettings`, params);
      },
      postUserEmailSetting(data) {
        return request.post(`/users-api/emailSettings`, data);
      },
      deleteUserEmailSetting(id) {
        return request.delete(`/users-api/emailSettings/${id}`);
      },
      getMarketplaceViewedItems(location, params) {
        return request.get(
          `/users-api/users/viewed-item-tracking/location/${location}`,
          params,
        );
      },
      updateMarketplaceViewedStatus(location, item, data) {
        return request.put(
          `/users-api/users/viewed-item-tracking/location/${location}/item/${item}`,
          data,
        );
      },
      getLeadSuppliers(params) {
        return request.get(`/users-api/lead-suppliers`, params);
      },
    };
  },
};

export default user;
